export default function FunnelChart({ funnel }) {
  const stages = (funnel.stages || []).filter((s) => !/ko|pers|negativ|black|non interessat|mai rispost|nunca|no tiene|lista negra|perdid|descartad/i.test(s.name));
  if (stages.length === 0) return null;
  const total = funnel.totale || 1;
  const closing = (s) => /chius|vint|consegn|won|ganad|entreg/i.test(s.name);
  return (
    <div data-testid={`funnel-${funnel.pipeline_id}`} className="space-y-1.5">
      {stages.map((s, i) => {
        const prev = i === 0 ? total : stages[i - 1].reached;
        const drop = prev ? Math.round((1 - s.reached / prev) * 100) : 0;
        const w = Math.max(2, (s.reached / total) * 100);
        return (
          <div key={s.stage_id} className="group grid grid-cols-[minmax(90px,1fr)_3fr_auto] items-center gap-2 sm:grid-cols-[minmax(120px,1fr)_3fr_auto] sm:gap-3" data-testid={`funnel-stage-${s.stage_id}`}>
            <div className="truncate text-xs text-slate-200" title={s.name}><span className="mr-1.5 tabular-nums text-slate-500">{i + 1}</span>{s.name}</div>
            <div className="relative h-7 overflow-hidden rounded-md bg-surface-2">
              <div className="h-full rounded-md transition-[width] duration-700"
                style={{ width: `${w}%`, background: closing(s) ? "#30d158" : "#e5e5ea" }} />
              {w >= 18
                ? <span className="absolute inset-y-0 left-2 flex items-center tabular-nums text-xs font-semibold text-[#1a1a1c]">{s.reached}</span>
                : <span className="absolute inset-y-0 flex items-center tabular-nums text-xs font-semibold text-slate-100" style={{ left: `calc(${w}% + 8px)` }}>{s.reached}</span>}
              {s.count > 0 && <span className="absolute inset-y-0 right-1 flex items-center"><span className="rounded-md bg-surface-2 px-1.5 py-0.5 text-xs text-slate-300">{s.count} qui ora</span></span>}
            </div>
            <div className="w-16 text-right tabular-nums text-xs sm:w-24">
              <span className="text-slate-100">{s.reached_pct}%</span>
              {i > 0 && drop > 0 && <span className="ml-1.5 text-red-400">−{drop}%</span>}
            </div>
          </div>
        );
      })}
      <div className="flex flex-col gap-1 pt-2 text-xs text-slate-500 sm:flex-row sm:justify-between">
        <span>{funnel.totale} opportunità nel periodo · {funnel.vinte} vinte · {funnel.perse} perse</span>
        <span>Barra = lead che hanno raggiunto almeno quella fase · rosso = calo rispetto alla fase precedente</span>
      </div>
    </div>
  );
}
